export const addDecimals = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

// NOTE: the code below has been changed from the course code to fix an issue
// with type coercion of strings to numbers.
// Our addDecimals function expects a number and returns a string, so it is not
// correct to call it passing a string as the argument.

export const updateCart = (state) => {
  const itemsPrice = state.cartItems.reduce((acc, item) => {
    const price = Number(item.offer_price ?? item.price ?? 0);
    return acc + price;
  }, 0);

  state.itemsPrice = addDecimals(itemsPrice);
  state.totalPrice = addDecimals(itemsPrice);

  // Save the cart to localStorage
  localStorage.setItem('cart', JSON.stringify(state));

  return state;
};